import { render, staticRenderFns } from "./Template7.vue?vue&type=template&id=97f34000"
import script from "./Template7.vue?vue&type=script&lang=js"
export * from "./Template7.vue?vue&type=script&lang=js"
import style0 from "./Template7.vue?vue&type=style&index=0&id=97f34000&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports